import { frontmanApi, METHOD } from '@/utils/api'

interface GetAuthResponse {
  code: string
  message: string
  errorDetails: string | null
  exceptionName: string | null
  reasonCode: string | null
}

// 쿠폰 조회 API이나, AK 인증을 위해서 사용
export function getIsValidAk() {
  return frontmanApi<GetAuthResponse>({
    method: METHOD.GET,
    path: '/flerken/api/v1/coupon-usage/$userKey',
    isErrorActionDisabled: true,
    disableAuth: true,
  })
}
